"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.actions2 = void 0;
var actionFlowOverlays_1 = require("./actionFlowOverlays");
/** Raw pack (taxonomy + UI). Flow is applied via configureActions2 / actionFlowOverlays. */
var actions2Raw = [
    {
        id: 400100,
        viewLevel: 2,
        taskImage: null,
        groupTitle: 'My',
        caption: 'Impact',
        cssStyle: { background: 'rgba(229,53,41,0.3)' },
        showBodyInput: true,
        bodyPlaceholder: 'impact',
        showValueInput: true,
        defaultValue: 1,
        flowKind: 'I',
        timeStyle: 'none',
        auditRow: {
            taskGroup: 'Activity',
            topicGroup: 'Consuming',
            topicDetail: 'My Impact',
            body: null,
            tagAux: null,
            value: null,
        },
    },
    {
        id: 400110,
        viewLevel: 2,
        taskImage: null,
        groupTitle: null,
        caption: 'Single occupant drive',
        cssStyle: { background: 'rgba(229,53,41,0.3)' },
        showBodyInput: false,
        bodyPlaceholder: 'impact',
        showValueInput: true,
        defaultValue: 1,
        flowKind: 'I',
        timeStyle: 'none',
        auditRow: {
            taskGroup: 'Activity',
            topicGroup: 'Consuming',
            topicDetail: 'My Impact',
            body: 'Single occupant drive',
            tagAux: null,
            value: null,
        },
    },
    {
        id: 400200,
        viewLevel: 2,
        taskImage: null,
        groupTitle: 'My',
        caption: 'Reduced',
        cssStyle: { background: 'rgba(40,220,41,0.3)' },
        showBodyInput: true,
        bodyPlaceholder: 'impact',
        auditRow: {
            taskGroup: 'Activity',
            topicGroup: 'Consuming',
            topicDetail: 'My Reduced Impact',
            body: null,
            tagAux: null,
            value: null,
        },
    },
    {
        id: 400210,
        viewLevel: 2,
        taskImage: null,
        groupTitle: null,
        caption: 'Avoided Disposable',
        cssStyle: { background: 'rgba(40,220,41,0.3)' },
        showBodyInput: true,
        defaultBody: 'Have in/Reusable',
        auditRow: {
            taskGroup: 'Activity',
            topicGroup: 'Consuming (Reduced)',
            topicDetail: 'My Reduced Impact',
            body: 'Have in/Reusable',
            tagAux: 'Avoided Disposable',
            value: null,
        },
    },
    {
        id: 410100,
        viewLevel: 2,
        taskImage: null,
        groupTitle: 'Noticed',
        caption: 'Impact',
        cssStyle: { background: 'rgba(229,53,41,0.3)' },
        showBodyInput: true,
        bodyPlaceholder: 'impact',
        showValueInput: true,
        defaultValue: 1,
        auditRow: {
            taskGroup: 'Audit',
            topicGroup: 'Consuming',
            topicDetail: 'Other Impact',
            body: null,
            tagAux: null,
            value: null,
        },
    },
    {
        id: 410110,
        viewLevel: 2,
        taskImage: null,
        groupTitle: 'Noticed',
        caption: 'Reduced',
        cssStyle: { background: 'rgba(40,220,41,0.3)' },
        showBodyInput: true,
        bodyPlaceholder: 'impact',
        showValueInput: true,
        defaultValue: 1,
        auditRow: {
            taskGroup: 'Activity',
            topicGroup: 'Consuming',
            topicDetail: 'Other Reduced Impact',
            body: null,
            tagAux: null,
            value: null,
        },
    },
    {
        id: 500100,
        viewGroup: 'Info, Impact, Focus-Nav',
        viewLevel: 0,
        taskImage: null,
        groupTitle: 'Idea',
        caption: 'Idea',
        cssStyle: { background: 'rgba(40,100,200,0.3)' },
        showBodyInput: true,
        // Activity taxonomy but NOT a timer — flowKind wins over taskGroup
        flowKind: 'I',
        timeStyle: 'none',
        auditRow: {
            taskGroup: 'Activity',
            topicGroup: 'Note',
            topicDetail: 'Idea',
            body: null,
            tagAux: null,
            value: null,
        },
    },
    {
        id: 50000100,
        viewGroup: 'Inventory, Logistics',
        viewLevel: 0,
        taskImage: null,
        groupTitle: 'Create',
        caption: 'Inventory',
        cssStyle: { background: 'rgba(40,100,200,0.2)' },
        showBodyInput: true,
        showTagAuxInput: true,
        tagAuxPlaceholder: 'code',
        showValueInput: true,
        defaultValue: 1,
        // Asset/item lifecycle — not human Focus T (may mean create or on-hand stamp)
        flowKind: 'L',
        timeStyle: 'stamp',
        auditRow: {
            taskGroup: 'Inventory',
            topicGroup: 'On Hand',
            topicDetail: 'In Progress',
            body: null,
            tagAux: null,
            value: 1,
        },
    },
    {
        id: 50008280,
        viewGroup: 'Logistics',
        viewLevel: 1,
        groupTitle: 'Removed',
        caption: 'Out',
        cssClass: 'asset-movement-out',
        showBodyInput: true,
        showTagAuxInput: true,
        tagAuxPlaceholder: 'code',
        showValueInput: true,
        defaultValue: 1,
        flowKind: 'L',
        timeStyle: 'stamp',
        auditRow: {
            taskGroup: 'Logistics',
            topicGroup: 'Other',
            topicDetail: 'Removed',
            body: null,
            tagAuxNumericPattern: null,
            tagAux: null,
            value: 1,
        },
    },
    {
        id: 50008290,
        viewGroup: 'Logistics',
        viewLevel: 1,
        groupTitle: 'Installed',
        caption: 'In',
        cssClass: 'asset-movement-in',
        showBodyInput: true,
        showTagAuxInput: true,
        tagAuxPlaceholder: 'code',
        showValueInput: true,
        defaultValue: 1,
        flowKind: 'L',
        timeStyle: 'stamp',
        auditRow: {
            taskGroup: 'Logistics',
            topicGroup: 'Other',
            topicDetail: 'Installed',
            body: null,
            tagAuxNumericPattern: null,
            tagAux: null,
            value: 1,
        },
    },
    {
        id: 50018200,
        viewGroup: 'Logistics',
        viewLevel: 1,
        groupTitle: 'Transfer',
        caption: 'Move',
        materialIcon: 'swap_horiz',
        cssClass: 'asset-movement-in',
        showBodyInput: true,
        showTagAuxInput: true,
        tagAuxPlaceholder: 'code',
        showValueInput: true,
        defaultValue: 1,
        flowKind: 'L',
        timeStyle: 'stamp',
        auditRow: {
            taskGroup: 'Logistics',
            topicGroup: 'Transfer to',
            topicDetail: 'In Progress',
            body: null,
            tagAuxNumericPattern: null,
            tagAux: null,
            value: 1,
        },
    },
    {
        id: 1300100,
        viewGroup: 'Info, Inventory, Impact, Focus-Nav',
        viewLevel: 0,
        taskImage: null,
        groupTitle: 'Any Audit',
        caption: 'Audit',
        cssStyle: { background: 'White' },
        showBodyInput: true,
        showTagAuxInput: true,
        tagAuxPlaceholder: 'code',
        showValueInput: true,
        defaultValue: 1,
        auditRow: {
            taskGroup: 'Audit',
            topicGroup: 'Other',
            body: null,
            tagAux: null,
            value: null,
        },
    },
    {
        id: 1300110,
        viewGroup: 'Info, Inventory, Impact, Focus-Nav',
        viewLevel: 0,
        materialIcon: 'info',
        taskImage: null,
        groupTitle: 'Any Info',
        caption: 'Info',
        cssStyle: { background: 'White' },
        showBodyInput: true,
        showTagAuxInput: true,
        tagAuxPlaceholder: 'ref',
        showValueInput: true,
        defaultValue: null,
        flowKind: 'I',
        timeStyle: 'none',
        auditRow: {
            taskGroup: 'Info',
            topicGroup: null,
            body: null,
            tagAux: null,
            value: null,
        },
    },
    {
        id: 1300200,
        viewGroup: 'Info, Focus-1, Focus-Nav',
        viewLevel: 0,
        taskImage: null,
        groupTitle: 'Any Note',
        caption: 'Note',
        cssStyle: { background: 'rgba(240,240,240,0.8)' },
        showBodyInput: true,
        showTagAuxInput: true,
        tagAuxPlaceholder: 'tag',
        showValueInput: false,
        defaultValue: null,
        flowKind: 'I',
        timeStyle: 'none',
        auditRow: {
            taskGroup: 'Info',
            topicGroup: 'Note',
            body: null,
            tagAux: null,
            value: null,
        },
    },
    {
        id: 1301200,
        viewGroup: 'Info, Inventory, Logistics, Impact',
        viewLevel: 0,
        taskImage: null,
        groupTitle: 'Any Activity',
        caption: 'Activity',
        cssStyle: { background: 'rgba(200,255,200,0.6)' },
        showBodyInput: true,
        showTagAuxInput: true,
        tagAuxPlaceholder: 'tag',
        showValueInput: false,
        defaultValue: null,
        // Explicit catch-all timer — not the same as every Activity/* taxonomy row
        flowKind: 'T',
        timeStyle: 'duration',
        opensFocus: true,
        closesPreviousT: true,
        auditRow: {
            taskGroup: 'Activity',
            topicGroup: 'Other',
            body: null,
            tagAux: null,
            value: null,
        },
    },
    {
        id: 1301300,
        viewGroup: 'Info, Inventory, Logistics, Impact, Focus-Escalated',
        viewLevel: 0,
        taskImage: null,
        groupTitle: 'Any Escalation',
        caption: 'Escalate',
        cssStyle: { background: 'rgba(240,40,40,0.6)' },
        showBodyInput: true,
        bodyPlaceholder: 'issue',
        showTagAuxInput: true,
        tagAuxPlaceholder: 'tag',
        showValueInput: true,
        defaultValue: 1,
        auditRow: {
            taskGroup: 'Escalated',
            topicGroup: 'Other',
            body: null,
            tagAux: null,
            value: 1,
        },
    },
    {
        id: 1301310,
        viewGroup: 'Info, Inventory, Logistics, Impact, Focus-Escalated',
        viewLevel: 0,
        taskImage: null,
        groupTitle: 'Esc. Level',
        caption: 'Escalate',
        cssStyle: { background: 'rgba(240,40,40,0.6)' },
        showBodyInput: true,
        bodyPlaceholder: 'issue',
        showTagAuxInput: true,
        tagAuxPlaceholder: 'tag',
        showValueInput: true,
        defaultValue: 2,
        auditRow: {
            taskGroup: 'Escalated',
            topicGroup: 'Other',
            body: null,
            tagAux: null,
            value: 2,
        },
    },
    {
        id: 1301400,
        groupTitle: 'Customer Service',
        tooltip: 'Customer Service general notes',
        defaultBody: '',
        defaultTagAux: '',
        addStatus: '',
        caption: 'Save',
        serviceRealm: 'bikeshare',
        sessionFocus: '',
        viewGroup: 'Session, Info, Inventory, Focus-Nav',
        viewLevel: 0,
        taskImage: '',
        showBodyInput: true,
        bodyPlaceholder: 'note',
        showTagAuxInput: true,
        tagAuxPlaceholder: 'tag',
        showValueInput: true,
        defaultValue: null,
        ver: 2,
        auditRow: {
            taskGroup: 'Activity',
            topicGroup: 'Customer Service',
            topicDetail: null,
            body: null,
            tagAux: '',
            value: null,
        },
        cssStyle: { background: 'rgba(40,240,100,0.6)' },
    },
    {
        id: 1301401,
        groupTitle: '',
        tooltip: 'Gross Misuse - Suspected Vandalism',
        defaultBody: 'GM-SV',
        defaultTagAux: 'GM-SV',
        addStatus: '@tagAux',
        caption: 'GM-SV',
        serviceRealm: 'bikeshare',
        sessionFocus: '',
        viewGroup: 'Session, Info, Inventory, Focus-Nav',
        viewLevel: 0,
        taskImage: '',
        showBodyInput: true,
        bodyPlaceholder: 'note',
        showTagAuxInput: true,
        tagAuxPlaceholder: 'tag',
        showValueInput: true,
        defaultValue: null,
        ver: 2,
        auditRow: {
            taskGroup: 'Activity',
            topicGroup: 'Customer Service',
            topicDetail: '',
            body: 'GM-SV',
            tagAux: 'GM-SV',
            value: null,
        },
        cssStyle: { background: 'rgba(40,240,100,0.6)' },
    },
    {
        id: 1302200,
        viewGroup: 'Info, Session',
        viewLevel: 0,
        taskImage: null,
        groupTitle: 'Meeting',
        caption: 'Meeting',
        cssStyle: { background: 'rgba(200,255,200,0.6)' },
        showBodyInput: true,
        showTagAuxInput: true,
        tagAuxPlaceholder: 'tag',
        showValueInput: false,
        defaultValue: null,
        auditRow: {
            taskGroup: 'Activity',
            topicGroup: 'Meeting',
            body: null,
            tagAux: null,
            value: null,
        },
    },
    {
        id: 1300300,
        viewGroup: 'Info',
        viewLevel: 1,
        taskImage: null,
        groupTitle: 'Code Snip',
        caption: 'Code',
        cssStyle: { background: 'rgba(140,140,140,0.4)' },
        showBodyInput: true,
        bodyPlaceholder: 'code',
        showTagAuxInput: true,
        tagAuxPlaceholder: 'tag',
        showValueInput: false,
        defaultValue: null,
        auditRow: {
            taskGroup: 'Info',
            topicGroup: 'Code',
            body: null,
            tagAux: null,
            value: null,
        },
    },
    {
        id: 1300400,
        viewGroup: 'Info',
        viewLevel: 1,
        taskImage: null,
        groupTitle: 'Any URI',
        caption: 'URI',
        cssStyle: { background: 'rgba(200,200,255,0.8)' },
        showBodyInput: true,
        showTagAuxInput: true,
        tagAuxPlaceholder: 'tag',
        showValueInput: false,
        defaultValue: null,
        auditRow: {
            taskGroup: 'Info',
            topicGroup: 'URI',
            body: null,
            tagAux: null,
            value: null,
        },
    },
    {
        id: 2300100,
        viewGroup: 'Info, Logistics',
        viewLevel: 1,
        taskImage: null,
        groupTitle: 'Tech Support',
        caption: 'Support',
        cssStyle: { background: 'rgba(100,150,255,0.4)' },
        showBodyInput: true,
        showTagAuxInput: true,
        tagAuxPlaceholder: 'tag',
        showValueInput: false,
        defaultValue: null,
        auditRow: {
            taskGroup: 'Activity',
            topicGroup: 'Assist',
            body: null,
            tagAux: null,
            value: null,
        },
    },
];
/** Configured pack — flowKind stack from actionFlowOverlays.ts */
exports.actions2 = (0, actionFlowOverlays_1.configureActions2)(actions2Raw);
